import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from "react-i18next";
import MenuPlanning1 from "./MenuPlanning1";
import MenuPlanning2 from "./MenuPlanning2";
import MenuListPlanning from "./MenuListPlanning";
import MenuListPlanningAccumulate from "./MenuListPlanningAccumulate";
import DialogItemDetail from "./DialogItemDetail";
import { makeStyles } from "@mui/styles";
import DialogManageWorkload from "./DialogManageWorkload";
import SimpleDialog from "../../components/SimpleDialog";
import ConfirmDialog from "../../components/ConfirmDialog";
import React, { useEffect } from "react";
import { ReactComponent as PdfIcon } from "../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../assets/images/iconFile/Null-File.svg";
import workloadAndPerformanceService from "../../services/workloadAndPerformance.service";

import {
    Alert,
    Grid,
} from "@mui/material";

const styles = {
    td: {
        fontSize: "18px",
        lineHeight: "24.59px",
        border: "none"
    },
    emtyData: {
        fontSize: "18px",
        lineHeight: "24.59px",
        color: "#A0A0A0",
    },
    span: {
        fontWeight: "500",
        // textDecoration: "underline",
        color: "#5DA196",
        cursor: "pointer"
    }
};
function Row(props) {
    const { row, classes, param, rubricCat, itemIndex, edit, add, id, del, select, allData,scroll,status,closeMenu } = props;
    const [open, setOpen] = React.useState(false);
    const [openWorkload, setOpenWorkload] = React.useState("");
    const { t } = useTranslation()
    const childrenRows = row?.portfolio ? row?.portfolio : [];
    const useStyles = makeStyles({
        tableBody: {
            backgroundColor: "unset !important",
            boxShadow: "none !important",
        },
        clickable: {
            cursor: "pointer",
            transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            '&:hover': {
                color: 'rgb(65, 112, 105) !important'
            }
        },
        border: {
            'td': {
                border: "none"
            }
        },
        des: {
            display: "-webkit-box",
            "-webkit-line-clamp": 2,
            "-webkit-box-orient": "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }
    });
    const classess = useStyles();
    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : (Math.round(sum * 100) / 100).toFixed(2)
        return scores
    }
    const openWorkloadForm = (value) => {
        setOpenWorkload(row?.serial)
    };
    const closeWorkload = (value) => {
        setOpenWorkload("")
    };
    const adds = (value) => {
        add(value)
    };
    const onDel = (value) => {
        del(value)
    };
    let selectWorkLoad = (value, rb_condition) => {
        select(value, rb_condition);
    }
    const openInNewTab = (val) => {
        workloadAndPerformanceService.openFiles(val).then(
            (response) => {
                const newWindow = window.open(response.data, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
            },
        );
    }
    let statusOpen = (value) => {
        status(value);
    }
    return (
        <React.Fragment>
            <TableRow classes={{ root: classess.border }}>
                <TableCell colSpan={8} sx={{ "padding": "10px 0px", "border": "none" }}>
                    <TableContainer sx={{ "border": "1px solid #E4E4E4", "borderRadius": "10px", }}>
                        <Table>
                            <TableBody component={Paper} classes={{ root: classess.tableBody }}>
                                <TableRow sx={{ "background-color": "white" }}>
                                    <TableCell sx={{ width: param.colWidth01, "border": "none" }} style={styles.td} >
                                        <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            onClick={() => setOpen(!open)}
                                            sx={{ padding: 0, backgroundColor: "#F5F5F5", borderRadius: 0 }}
                                        >
                                            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                                        </IconButton>
                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth02, "border": "none" }} style={styles.td}>{row.code}</TableCell>
                                    <TableCell sx={{ width: param.colWidth03, "border": "none" }} style={styles.td}>
                                        <Typography classes={{ root: classess.des }}>
                                            {row.description}
                                        </Typography>
                                        {row.remark.length > 0 ?
                                            <Typography classes={{ root: classess.des }} sx={{ paddingTop: "5px", color: "#939393", fontWeight: "400" }}>
                                                หมายเหตุ: <span style={{ fontWeight: "300", paddingLeft: "5px" }}>{row.remark}</span>
                                            </Typography>
                                            : null
                                        }
                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth04, "border": "none" }} style={styles.td}>{row.quantity} {row.unit.description}</TableCell>
                                    <TableCell sx={{ width: param.colWidth05, "border": "none" }} style={styles.td}>{row.worth}</TableCell>
                                    <TableCell sx={{ width: param.colWidth06, "border": "none" }} style={styles.td}>{calculateScore(row)}</TableCell>
                                    <TableCell sx={{ width: param.colWidth07, "border": "none", 'text-align': 'end' }} style={styles.td}>
                                        {edit ? <>
                                            {/* <MenuPlanning1 rubricCat={rubricCat} itemIndex={itemIndex} row={row} add={adds} onDel={onDel} select={selectWorkLoad} id={row?.serial} allData={allData} /> */}
                                            <MenuListPlanning closeMenu={closeMenu} status={statusOpen} rubricCat={rubricCat} itemIndex={itemIndex} row={row} add={adds} onDel={onDel} select={selectWorkLoad} id={row?.serial} allData={allData} scroll={scroll}/>
                                        </>
                                            : null}

                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth08, "border": "none" }} style={styles.td}></TableCell>
                                </TableRow>
                                <TableRow sx={{ "background-color": "#F5F5F5" }}>
                                    <TableCell colSpan={8} sx={{ "padding": "0px", "border": "none" }}>
                                        <Collapse in={open} timeout="auto" unmountOnExit>
                                            <Table>
                                                <TableHead>
                                                    <TableRow sx={{ "background-color": "#33619926" }}>
                                                        <TableCell sx={{ width: param.colWidth01, "border": "none" }}></TableCell>
                                                        <TableCell sx={{ width: param.colWidth02, "border": "none" }}></TableCell>
                                                        <TableCell sx={{ width: param.colWidth03, "border": "none" }} colSpan={6}>
                                                            <Typography variant="label" sx={{ "color": "#404349" }} pr={1}>
                                                                รายละเอียดภาระงานและผลงาน
                                                            </Typography>
                                                            <Typography variant="label_sub1" sx={{ "color": "#404349", fontSize: "13px" }}>
                                                                (ภาระงานที่แสดงผล เป็นเพียงการดึงข้อมูลเบื้องต้นมาจากระบบเท่านั้น
                                                                สามารถแก้ได้หรือเปลี่ยนแปลงได้ภายหลัง)
                                                            </Typography>
                                                        </TableCell>
                                                        {/*<TableCell sx={{ width : param.colWidth04}}>{t('label.amountOfWork')}</TableCell>*/}
                                                        {/*<TableCell sx={{ width : param.colWidth05}}>{t('label.workValue')}</TableCell>*/}
                                                        {/*<TableCell sx={{ width : param.colWidth06}}>{t('label.score')}</TableCell>*/}
                                                        {/*<TableCell sx={{ width : param.colWidth07}}></TableCell>*/}
                                                    </TableRow>
                                                </TableHead>
                                                <TableHead sx={{ "background-color": "#F9FBFD" }}>
                                                    <TableRow>
                                                        <TableCell sx={{ width: param.colWidth01, "border": "none" }}></TableCell>
                                                        <TableCell sx={{ width: param.colWidth03, "border": "none" }} className={classes["td-underline"]}>{t('label.code')}</TableCell>
                                                        <TableCell sx={{ width: param.colWidth03, "border": "none" }} className={classes["td-underline"]}>{t('label.workloadDetail')}</TableCell>
                                                        <TableCell sx={{ width: param.colWidth04, "border": "none" }} className={classes["td-underline"]}>{t('label.amountOfWork')}</TableCell>
                                                        {/* <TableCell sx={{ width: param.colWidth05, "border": "none" }} className={classes["td-underline"]}>{t('label.workValue')}</TableCell>
                                                        <TableCell sx={{ width: param.colWidth06, "border": "none" }} className={classes["td-underline"]}>{t('label.score')}</TableCell> */}
                                                        <TableCell sx={{ width: param.colWidth07, "border": "none", 'text-align': 'end' }} className={classes["td-underline"]}></TableCell>
                                                        <TableCell sx={{ width: param.colWidth08, "border": "none" }}></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody sx={{ "background-color": "#F9FBFD" }} id="tested">
                                                    {!childrenRows.length ? (
                                                        <TableRow sx={{ "background-color": "white" }} component={Paper}>
                                                            {!edit ?
                                                                <TableCell colSpan={8} align="center" style={styles.emtyData} sx={{ "border": "none" }}>
                                                                    ยังไม่มีข้อมูล</TableCell>
                                                                :
                                                                <TableCell colSpan={8} align="center" style={styles.emtyData} sx={{ "border": "none" }}>
                                                                    ยังไม่มีข้อมูล หากต้องการเพิ่มรายละเอียดภาระงานและผลงาน <br />
                                                                    ให้กดปุ่มเลือกภาระงานและผลงาน หรือ <Typography component="span" classes={{ root: classes.clickable }} style={styles.span} onClick={openWorkloadForm}>คลิกที่นี่</Typography></TableCell>
                                                            }
                                                        </TableRow>
                                                    ) : (childrenRows.map((loItem, lvIndex) =>
                                                    (<TableRow key="row.itemCode">
                                                        <TableCell sx={{ width: param.colWidth01, "border": "none" }}></TableCell>
                                                        <TableCell sx={{ width: param.colWidth02, "border": "none" }} className={classes["td-children-underline"]}>{loItem.code}</TableCell>
                                                        <TableCell sx={{ width: param.colWidth03, "border": "none" }} className={classes["td-children-underline"]}>
                                                            <Typography component="span" classes={{ root: classess.des }}>{loItem.description}</Typography>
                                                            <Typography variant="dashed-solid"
                                                                pr={1}
                                                                pl={1}
                                                                sx={{
                                                                    'display': loItem.optional ? 'inline' : 'none',
                                                                    'border': '1px solid #393939',
                                                                    borderRadius: '4px',
                                                                    'fontSize': '13px',
                                                                    // 'padding-left': '5px',
                                                                    // 'padding-right': '5px'
                                                                }}>{loItem.optional}</Typography>
                                                            {/* {console.log(loItem.files)} */}
                                                            {loItem.files !== undefined ?
                                                                loItem.files.map((item) => (
                                                                    <Box display="flex" sx={{ paddingTop: "20px" }}>
                                                                        <Box sx={{ width: "24px", height: "24px" }}>
                                                                            {item.value.mimetype === "application/pdf" ?
                                                                                <PdfIcon /> :
                                                                                item.value.mimetype === "image/png" ?
                                                                                    <PngIcon /> :
                                                                                    item.value.mimetype === "image/jpeg" ?
                                                                                        <JpgIcon /> : <NullIcon />
                                                                            }
                                                                        </Box>
                                                                        <Typography pl={1} sx={{ textDecoration: "underline", cursor: "pointer" }} classes={{ root: classess.des }} onClick={() => openInNewTab(item.value.serial)}>{item.value.name}</Typography>
                                                                    </Box>
                                                                ))
                                                                : null
                                                            }
                                                        </TableCell>
                                                        <TableCell sx={{ width: param.colWidth04, "border": "none" }} className={classes["td-children-underline"]}>{loItem.quantity} {loItem.unit.description}</TableCell>
                                                        {/* <TableCell sx={{ width: param.colWidth05, "border": "none" }} className={classes["td-children-underline"]}>{loItem.value} </TableCell>
                                                        <TableCell sx={{ width: param.colWidth06, "border": "none" }} className={classes["td-children-underline"]}><Typography color="primary">{loItem.score}</Typography> </TableCell> */}
                                                        <TableCell sx={{ width: param.colWidth07, "border": "none", 'text-align': 'end' }} className={classes["td-children-underline"]}>
                                                            <DialogItemDetail id={loItem.serial} />
                                                        </TableCell>
                                                        <TableCell sx={{ width: param.colWidth08, "border": "none" }}></TableCell>
                                                    </TableRow>)
                                                    ))}
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ "border": "none" }}>
                                                            {/*<Button variant="dashed-solid" sx={{'border': '1px solid #393939'}}>{t('planning.label.manageWorkload')}</Button>*/}
                                                            {!edit ?
                                                                null :
                                                                <DialogManageWorkload select={selectWorkLoad} rubricCat={rubricCat} openWorkload={openWorkload} closeWorkload={closeWorkload} row={row} id={row?.serial} itemIndex={itemIndex} allData={allData} />
                                                            }

                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

function Accumulate(props) {
    const { text, accumulate_use, param, edit, onDel, onEdit,scroll,status,closeMenu } = props;
    const [open, setOpen] = React.useState(false);
    const { t } = useTranslation()
    const useStyles = makeStyles({
        tableBody: {
            backgroundColor: "unset !important",
            boxShadow: "none !important",
        },
        border: {
            'td': {
                border: "none"
            }
        },
        des: {
            display: "-webkit-box",
            "-webkit-line-clamp": 2,
            "-webkit-box-orient": "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }
    });
    const classess = useStyles();
    const handleClose = () => {
        onDel()
    };
    let editAcc = () => {
        onEdit();
    }
    let statusOpen = (value) => {
        status(value);
    }
    return (
        <React.Fragment>
            <TableRow classes={{ root: classess.border }}>
                <TableCell colSpan={8} sx={{ "padding": "10px 0px", "border": "none" }}>
                    <TableContainer sx={{ "border": "1px solid #E4E4E4", "borderRadius": "10px", }}>
                        <Table>
                            <TableBody component={Paper} classes={{ root: classess.tableBody }}>
                                <TableRow sx={{ "background-color": "white" }}>
                                    <TableCell sx={{ width: param.colWidth01, "border": "none" }} style={styles.td} >
                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth02, "border": "none" }} style={styles.td}>-</TableCell>
                                    <TableCell sx={{ width: param.colWidth03, "border": "none" }} style={styles.td}>
                                        <Typography classes={{ root: classess.des }}>
                                            คะแนนยกยอด{text}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth04, "border": "none" }} style={styles.td}></TableCell>
                                    <TableCell sx={{ width: param.colWidth05, "border": "none" }} style={styles.td}></TableCell>
                                    <TableCell sx={{ width: param.colWidth06, "border": "none" }} style={styles.td}>{Number(accumulate_use).toFixed(2)}</TableCell>
                                    <TableCell sx={{ width: param.colWidth07, "border": "none", 'text-align': 'end' }} style={styles.td}>
                                        {edit ? <>
                                            <MenuListPlanningAccumulate status={statusOpen} closeMenu={closeMenu} onDel={handleClose} onEdit={editAcc} scroll={scroll}/>
                                        </>
                                            : null}

                                    </TableCell>
                                    <TableCell sx={{ width: param.colWidth08, "border": "none" }} style={styles.td}></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
Row.propTypes = {
    row: PropTypes.shape({
        calories: PropTypes.number.isRequired,
        carbs: PropTypes.number.isRequired,
        fat: PropTypes.number.isRequired,
        history: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.number.isRequired,
                customerId: PropTypes.string.isRequired,
                date: PropTypes.string.isRequired,
            }),
        ).isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        protein: PropTypes.number.isRequired,
    }).isRequired,
};
export default function CollapsibleTable2(props) {
    const { t } = useTranslation()
    const { datas, rubricCat, edit, save, editData, id, select, delAccumulate, editAccumulate, allData, openAdd,scroll,closeMenu,status } = props;
    const param = {
        colWidth01: '60px',
        colWidth02: '90px',
        colWidth03: 'auto',
        colWidth04: '150px',
        colWidth05: '150px',
        colWidth06: '150px',
        colWidth07: '150px',
        colWidth08: '60px',
    }
    const useStyles = makeStyles({
        "td-underline": {
            "border-bottom": "1px solid #A0A0A0 !important",
            "color": "#A0A0A0 !important"
        },
        "td-children-underline": {
            "border-bottom": "1px solid #E5E5E5 !important",
            "color": "#404349 !important"
        },
        clickable: {
            cursor: "pointer",
            transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            '&:hover': {
                color: 'rgb(65, 112, 105) !important'
            }
        },
        tableBody: {
            backgroundColor: "unset !important",
            boxShadow: "none !important",
        },
        th: {
            border: "none !important"
        }
    });
    const classes = useStyles();
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [isDelete, setDelete] = React.useState({});
    const adds = (value) => {
        editData(value, "edit")
    };
    const del = (value) => {
        // handleConfirmDeleteDialog(true)
        setDelete({ ...value, rubricCat: rubricCat?.serial })
        editData({ ...value, rubricCat: rubricCat?.serial }, "del")

    };
    const openAddForm = () => {
        openAdd(rubricCat?.serial);
    }
    const handleConfirmDeleteDialog = (val) => {
        openConfirmDeleteDialog(val)
    };
    const handleConfirmDeleteList = () => {
        handleConfirmDeleteDialog(false)
        openSuccessDeleteDialog(true)
    };
    let selectWorkLoad = (value, rb_condition) => {
        select(value, rubricCat?.serial, rb_condition);
    }
    let delAcc = (value, rb_condition) => {
        delAccumulate(0, rubricCat.serial);
    }
    let editAcc = () => {
        editAccumulate(rubricCat.serial);
    }
    let statusOpen = (value) => {
        status(value);
    }
    // const checkError = () => {
    //     if (rubricCat !== undefined && rubricCat !== null && rubricCat !== "null") {
    //         for (let index = 0; index <= Object.keys(dataError.category).length - 1 ; index++) {
    //             if (rubricCat.serial === Object.keys(dataError.category)[index]) {
    //                 console.log(dataError.category[Object.keys(dataError.category)[index]],55);
    //                 // for (let indexs = 0; indexs <= dataError.category[Object.keys(dataError.category)[index]].length - 1; indexs++) {
    //                 //     console.log(dataError.category[Object.keys(dataError.category)][indexs]);
    //                 // }
    //             }
    //         }
    //     }
    // };
    return (
        <>
            <TableContainer>
                <Table aria-label="collapsible table" sx={{
                    "border-collapse": "separate",
                    "border-spacing": "0 14px"
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: param.colWidth01 }} className={classes.th}></TableCell>
                            <TableCell sx={{ width: param.colWidth02 }} className={classes["td-underline"]}><Typography variant="label" color="#A0A0A0">{t('label.code')}</Typography></TableCell>
                            <TableCell sx={{ width: param.colWidth03 }} className={classes["td-underline"]}><Typography variant="label" color="#A0A0A0">{t('label.evalDetail')}</Typography></TableCell>
                            <TableCell sx={{ width: param.colWidth04 }} className={classes["td-underline"]}><Typography variant="label" color="#A0A0A0">{t('label.amountOfWork')}</Typography></TableCell>
                            <TableCell sx={{ width: param.colWidth05 }} className={classes["td-underline"]}><Typography variant="label" color="#A0A0A0">{t('label.workValue')}</Typography></TableCell>
                            <TableCell sx={{ width: param.colWidth06 }} className={classes["td-underline"]}><Typography variant="label" color="#A0A0A0">{t('label.score')}</Typography></TableCell>
                            <TableCell sx={{ width: param.colWidth07 }} className={classes["td-underline"]}> </TableCell>
                            <TableCell sx={{ width: param.colWidth08 }} className={classes.th}> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody classes={{ root: classes.tableBody }}>
                        {rubricCat?.accumulate_use_data !== undefined && rubricCat?.accumulate_use_data !== null && Number(rubricCat?.accumulate_use) > 0 ?
                            <Accumulate closeMenu={closeMenu} status={statusOpen} accumulate_use={rubricCat?.accumulate_use} text={rubricCat?.description} param={param} edit={edit} onDel={delAcc} onEdit={editAcc} />
                            : null}
                        {datas !== undefined && datas !== null && datas.length > 0 ?
                            (
                                datas.map((row, lvIndex) => (
                                    <Row key={row.name} row={row} param={param} edit={edit} add={adds} id={id} del={del} select={selectWorkLoad} allData={allData}
                                        itemIndex={lvIndex} closeMenu={closeMenu} status={statusOpen}
                                        classes={classes} rubricCat={rubricCat} scroll={scroll}/>
                                ))
                            ) : rubricCat?.accumulate_use_data !== undefined && rubricCat?.accumulate_use_data !== null && Number(rubricCat?.accumulate_use) > 0 ? null :
                                (
                                    <TableRow>
                                        <TableCell colSpan={8} sx={{ "padding": "10px 0", "border": "none" }}>
                                            <TableContainer sx={{ "border": "1px solid #E4E4E4", "borderRadius": "10px", }}>
                                                <Table>
                                                    <TableBody component={Paper}>
                                                        <TableRow sx={{ "background-color": "white" }} component={Paper}>
                                                            {!edit ?
                                                                <TableCell colSpan={8} align="center" style={styles.emtyData}>
                                                                    ยังไม่มีข้อมูล</TableCell>
                                                                :
                                                                <TableCell colSpan={8} align="center" style={styles.emtyData}>
                                                                    ยังไม่มีข้อมูล หากต้องการเพิ่มรายละเอียดข้อตกลง <br />
                                                                    ให้กดปุ่มเพิ่มข้อตกลงภาระงาน หรือ <Typography component="span" classes={{ root: classes.clickable }} style={styles.span} onClick={openAddForm}>คลิกที่นี่</Typography></TableCell>
                                                            }
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TableCell>
                                    </TableRow>
                                )
                        }
                        {/*{data.map((row) => (*/}
                        {/*    <Row key={row.name} row={row} param={param} classes={classes}/>*/}
                        {/*))}*/}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* {save ?
                rubricCat === "teaching" ?
                    <Grid container>
                        <Grid item>
                            <Alert
                                icon={false}
                                sx={{ color: "#CC6058", background: "#CC60581A" }}
                            >
                                <Typography>
                                    • คะแนนภาระงานสอนต่ำกว่าหลักเกณฑ์กำหนด
                                </Typography>
                            </Alert>
                        </Grid>
                    </Grid>
                    : rubricCat === "research" ?
                        <Grid container>
                            <Grid item>
                                <Alert
                                    icon={false}
                                    sx={{ color: "#EFAD0A", background: "#EFAD0A1A" }}
                                >
                                    <Typography>
                                        • คะแนนภาระงานวิจัยและงานวิชาการอื่นต่ำกว่าหลักเกณฑ์กำหนด
                                    </Typography>
                                </Alert>
                            </Grid>
                        </Grid>
                    : rubricCat === "service" ?
                        <Grid container>
                            <Grid item>
                                <Alert
                                    icon={false}
                                    sx={{ color: "#EFAD0A", background: "#EFAD0A1A" }}
                                >
                                    <Typography>
                                        • คะแนนภาระงานบริการวิชาการภายในต่ำกว่าหลักเกณฑ์กำหนด
                                    </Typography>
                                </Alert>
                            </Grid>
                        </Grid>
                    : rubricCat === "academicPublishing" ?
                        <Grid container>
                            <Grid item>
                                <Alert
                                    icon={false}
                                    sx={{ color: "#EFAD0A", background: "#EFAD0A1A" }}
                                >
                                    <Typography>
                                        • คะแนนภาระงานบริการวิชาการภายนอกต่ำกว่าหลักเกณฑ์กำหนด
                                    </Typography>
                                </Alert>
                            </Grid>
                        </Grid>
                    : null
                :
                null
            } */}
            <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title="ยืนยันการลบข้อตกลงภาระงาน" text="ต้องการยืนยันการลบรายการข้อตกลงภาระงานหรือไม่ ?" />
            <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} text="การลบรายการข้อตกลงภาระงาน" />
        </>
    );
}

